import { enviroments } from '@infrastructure/enviroments';
import { base } from '@service/base';
import { PageLimitFilter } from '@typings';

import { UpsellFlow } from 'src/models';

const BASE_URL = enviroments.BASE_URL;

export async function getAllUpsellFlow({
  page,
  limit,
  filter,
  order: ordered,
}: PageLimitFilter): Promise<UpsellFlow.TUpsellFlowResponse> {
  let where = {};
  if (filter) {
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        where = {
          ...where,
          [key]: filter[key],
        };
      }
    });
  }

  const order = !ordered || ordered === '' ? '[id,ASC]' : ordered;

  const response = await base({
    baseURL: BASE_URL,
    url: `/funnel/flow`,
    method: 'GET',
    params: {
      ...where,
      limit,
      page,
      order,
    },
  });

  return {
    count: response.data.total,
    rows: response.data.data,
  };
}
